var _filter, _filter2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppropriatenessAssessmentQuestionFive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "brightness"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0.65
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "brightness-dark"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0.4
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0.4
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0.4
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.594 83C64.5658 83 83.1881 64.4198 83.1881 41.5C83.1881 18.5802 64.5658 0 41.594 0C18.6223 0 0 18.5802 0 41.5C0 64.4198 18.6223 83 41.594 83Z",
    fill: "#242D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7508 52.1664L20.5195 51.1983L29.1354 40.2327C29.2542 40.0816 29.4243 39.9794 29.6135 39.9456C29.8027 39.9118 29.9977 39.9487 30.1615 40.0494L39.7658 45.9599L58.9134 22.9829L60.1165 23.9871L40.535 47.4849C40.4143 47.6295 40.2457 47.7258 40.0598 47.7561C39.874 47.7865 39.6834 47.7489 39.523 47.6502L29.9351 41.7498L21.7508 52.1664Z",
    fill: "#E6E8EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    filter: "url(#brightness-dark)",
    d: "M52.4652 40.7166L40.7163 53.7257L30.5339 47.7659L21.1348 59.5148V64.9976H61.0811V59.5148L52.4652 40.7166Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    filter: "url(#brightness)",
    d: "M40.7176 53.7259V64.9979H30.5352V47.7661L40.7176 53.7259Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    filter: "url(#brightness)",
    d: "M52.4648 64.9976V40.7166L61.0807 59.5148V64.9976H52.4648Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0319 37.5837C59.2229 37.5837 63.4311 33.3755 63.4311 28.1845C63.4311 22.9935 59.2229 18.7854 54.0319 18.7854C48.8409 18.7854 44.6328 22.9935 44.6328 28.1845C44.6328 33.3755 48.8409 37.5837 54.0319 37.5837Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8984 21.9185H57.1645L54.0315 29.7511L50.8984 21.9185Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0314 34.4507C54.8965 34.4507 55.5979 33.7493 55.5979 32.8841C55.5979 32.019 54.8965 31.3176 54.0314 31.3176C53.1662 31.3176 52.4648 32.019 52.4648 32.8841C52.4648 33.7493 53.1662 34.4507 54.0314 34.4507Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.002 65.7809H65.7809V64.2144H18.7853V17.2188H17.2188V64.9977C17.2188 65.2054 17.3013 65.4046 17.4482 65.5515C17.5951 65.6984 17.7943 65.7809 18.002 65.7809Z",
    fill: "#415360"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0202 55.2282L63.3614 53.8065L64.7831 53.1486L65.441 54.571L64.0202 55.2282ZM62.7027 52.3873L62.044 50.9664L63.4656 50.3069L64.1243 51.7285L62.7027 52.3873ZM61.3861 49.544L60.7266 48.1224L62.1482 47.4629L62.8069 48.8845L61.3861 49.544ZM60.0686 46.7008L59.4099 45.2784L60.8307 44.6205L61.4895 46.0429L60.0686 46.7008ZM58.7512 43.8583L58.0924 42.4399L59.5149 41.7772L60.1736 43.1988L58.7512 43.8583ZM57.4337 41.0159L56.7734 39.5943L58.1943 38.9355L58.853 40.3564L57.4337 41.0159Z",
    fill: "#E6E8EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppropriatenessAssessmentQuestionFive);
export default __webpack_public_path__ + "static/media/AppropriatenessAssessmentQuestionFive.457bdc1dbd791adc00cfe10e8c31fad2.svg";
export { ForwardRef as ReactComponent };